import { useQuery } from '@hooks/reactQuery';

import { getHistoryPassword2Fa } from '@api/userProfile';

import { PASSWORD_HISTORY_2FA } from '@constants/queryKeys';

export const useQuery2FaPasswordHistory = () => {
	const {
		data: leftSeconds,
		isLoading: isLoadingHistory,
		isFetching: isFetchingHistory,
	} = useQuery<number>({
		queryKey: [PASSWORD_HISTORY_2FA],
		queryFn: getHistoryPassword2Fa,
	});

	return {
		isLoadingHistory: isLoadingHistory || isFetchingHistory,
		leftSeconds,
	};
};
